import { createSlice } from "@reduxjs/toolkit";
import { TournamentState } from "../types/state";
import { LOADING } from "../../../types";
import { addTournament } from "../actions/add";
import { deleteTournament } from "../actions/delete";
import { toggleTournamentVisibility } from "../actions/toggleVisibility";
import { setTournamentError } from "../actions/setError";
import { setTournamentData } from "../actions/setData";

const initialState: TournamentState = {
  data: null,
  loading: LOADING.IDLE,
  error: null,
};

export const tournamentSlice = createSlice({
  name: "tournament",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(setTournamentError, (state, { payload: error }) => {
        state.error = error;
        state.loading = LOADING.IDLE;
        state.data = null;
      })
      .addCase(setTournamentData, (state, { payload: tournaments }) => {
        state.data = tournaments;
        state.error = null;
        state.loading = LOADING.IDLE;
      })
      .addCase(addTournament.fulfilled, (state) => {
        state.error = null;
        state.loading = LOADING.IDLE;
      })
      .addCase(addTournament.rejected, (state, { payload: error }) => {
        state.loading = LOADING.IDLE;
        state.error = error as string | null;
      })
      .addCase(addTournament.pending, (state) => {
        state.loading = LOADING.PENDING;
        state.error = null;
      })
      .addCase(deleteTournament.fulfilled, (state) => {
        state.error = null;
        state.loading = LOADING.IDLE;
      })
      .addCase(deleteTournament.rejected, (state, { payload: error }) => {
        state.loading = LOADING.IDLE;
        state.error = error as string | null;
      })
      .addCase(deleteTournament.pending, (state) => {
        state.loading = LOADING.PENDING;
        state.error = null;
      })
      .addCase(toggleTournamentVisibility.fulfilled, (state) => {
        state.error = null;
        state.loading = LOADING.IDLE;
      })
      .addCase(
        toggleTournamentVisibility.rejected,
        (state, { payload: error }) => {
          state.loading = LOADING.IDLE;
          state.error = error as string | null;
        },
      )
      .addCase(toggleTournamentVisibility.pending, (state) => {
        state.loading = LOADING.PENDING;
        state.error = null;
      });
  },
});
